import { Map } from 'immutable';

import * as type from './actionTypes';
import { ASSIGNED_TO_WRITERS_REPORT_LOADING } from './components/AssignedToWritersReport/reportStates';
import {
  AUDIO_ABBREVIATIONS_REPORT_LOADING,
  AUDIO_ABBREVIATIONS_REPORT_SUCCESS,
} from './components/AudioAbbreviationsReport/reportStates';
import {
  BOOKS_MISSING_ANSWERS_REPORT_LOADING,
  BOOKS_MISSING_ANSWERS_REPORT_SUCCESS,
} from './components/BooksMissingAnswersReport/reportStates';
import {
  INTERCOM_ACTIVE_USERS_REPORT_LOADING,
  INTERCOM_ACTIVE_USERS_REPORT_SUCCESS,
} from './components/IntercomActiveUsersReport/reportStates';
import { REFERRED_LEADS_REPORT_LOADING } from './components/ReferredLeadsReport/reportStates';
import { SELF_PROMOTION_REPORT_LOADING } from './components/SelfPromotionReport/reportStates';

const initialState = Map({
  bibliographyCSVJsonReport: [],
  userSubmittedQuestionsReportCSVJson: [],
  isUserSubmittedQuestionsReportLoading: false,
  userSubmittedQuestionsReportError: '',
  isLoading: false,
  errorMessage: '',
  usersCount: [],
  setGraph: { labels: '', datasets: [] },
  completionStatus: [],
  activeSubscriptionError: false,
  csvDataAvailably: false,
  automaticMasterReportData: [],
  automaticSubscriptionsReport: [],
  csvDataSubsActive: false,
  numberOfQuestionsPerRatingExamReportData: [],
  numberOfQuestionsPerRatingExamReportHasMore: true,
  nextRateToUse: '',
  numberOfQuestionsPerRatingExamReportOverallUnique: 0,
  numberOfQuestionsPerRatingExamReportApiError: false,
  intercomActiveUsersReport: {
    data: {},
    state: 'IDLE',
  },
  /* Favorite Questions Report */
  loadingFavoriteQuestionsReports: false,
  lastFavoriteQuestionsReports: null,
  /* Rate Questions Report */
  lastRateQuestionsReports: null,
  /* Usage Statistics Report */
  usageStatisticsReports: [],
  usageStatisticsReportsIsLoading: false,
  /* Subscription Types Report */
  subscriptionTypesReports: [],
  subscriptionTypesReportsIsLoading: false,
  /* Books missing answers report */
  booksMissingAnswersReportData: {
    link: '',
    state: BOOKS_MISSING_ANSWERS_REPORT_LOADING,
  },
  booksMissingAnswersReportState: BOOKS_MISSING_ANSWERS_REPORT_LOADING,
  // Audio Report
  audioReportsState: {},
  audioReportsData: {},
  audioAbbreviationReport: {
    data: {},
    state: 'IDLE',
  },
  /* Referred Leads Report */
  referredLeadsReportData: {
    link: '',
    state: REFERRED_LEADS_REPORT_LOADING,
  },
  referredLeadsReportState: REFERRED_LEADS_REPORT_LOADING,
  /* Assigned to Writers Report */
  assignedToWritersReportData: {
    link: '',
    state: ASSIGNED_TO_WRITERS_REPORT_LOADING,
  },
  assignedToWritersReportState: ASSIGNED_TO_WRITERS_REPORT_LOADING,
  /* Self Promotion Status Report */
  selfPromotionReportData: { link: '', state: SELF_PROMOTION_REPORT_LOADING },
  selfPromotionReportState: SELF_PROMOTION_REPORT_LOADING,
});

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_BIBLIOGRAPHY_REPORT_FOR_RATES:
      return state
        .set('isLoading', true)
        .set('errorMessage', '')
        .set('bibliographyCSVJsonReport', []);
    case type.SET_GRAPH:
      return state.set('setGraph', action.graph);
    case type.CALL_USERS_COUNT:
      return state.set('isLoading', true);
    case type.GET_BIBLIOGRAPHY_REPORT_FOR_RATES_SUCCESS:
      return state
        .set('isLoading', false)
        .set('bibliographyCSVJsonReport', action.bibliographyReportCSVJsonData);
    case type.GET_BIBLIOGRAPHY_REPORT_FOR_RATES_ERROR:
      return state
        .set('isLoading', false)
        .set('errorMessage', action.errorMessage);
    case type.GET_USERS_COUNT:
      return state
        .set('isLoding', true)
        .set('errorMessage', '')
        .set('usersCount', []);
    case type.GET_USERS_COUNT_SUCCESS:
      return state
        .set('isLoading', false)
        .set('usersCount', action.usersCountData);
    case type.GET_USERS_COUNT_ERROR:
      return state
        .set('isLoading', false)
        .set('usersCount', [])
        .set('errorMessage', action.errorMessage);
    case type.GET_COMPLETION_STATUS:
      return state.set('completionStatus', action.data);
    case type.SET_NUMBER_OF_QUESTIONS_ENABLED_PER_RATING_EXAM_REPORT: {
      const previousOverallUnique = state.get(
        'numberOfQuestionsPerRatingExamReportOverallUnique',
      );
      const newOverallUnique =
        previousOverallUnique + action.response.overallUnique;
      const numberOfQuestionsCurrentData = state.get(
        'numberOfQuestionsPerRatingExamReportData',
      );
      let numberOfQuestionsConcatData = numberOfQuestionsCurrentData.concat(
        action.response.data,
      );
      if (!action.response.hasMore) {
        const numberOfQuestionsFinalCSV = [
          ['OVERALL UNIQUE', newOverallUnique],
        ];
        numberOfQuestionsConcatData = numberOfQuestionsFinalCSV.concat(
          numberOfQuestionsConcatData,
        );
      }
      return state
        .set(
          'numberOfQuestionsPerRatingExamReportData',
          numberOfQuestionsConcatData,
        )
        .set(
          'numberOfQuestionsPerRatingExamReportHasMore',
          action.response.hasMore,
        )
        .set('nextRateToUse', action.response.nextRateToUse)
        .set(
          'numberOfQuestionsPerRatingExamReportOverallUnique',
          newOverallUnique,
        );
    }
    case type.CLEAR_NUMBER_OF_QUESTIONS_ENABLED_PER_RATING_EXAM_REPORT_PROPS:
      return state
        .set('numberOfQuestionsPerRatingExamReportData', [])
        .set('numberOfQuestionsPerRatingExamReportHasMore', true)
        .set('nextRateToUse', '')
        .set('numberOfQuestionsPerRatingExamReportOverallUnique', 0)
        .set('numberOfQuestionsPerRatingExamReportApiError', false);

    case type.SET_NUMBER_OF_QUESTIONS_ENABLED_PER_RATING_EXAM_REPORT_ERROR:
      return state.set('numberOfQuestionsPerRatingExamReportApiError', true);

    case type.CLEAR_NUMBER_OF_QUESTIONS_ENABLED_PER_RATING_EXAM_API_ERROR:
      return state.set('numberOfQuestionsPerRatingExamReportApiError', false);

    case type.SET_ALL_MASTER_USER_REPORT: {
      const automaticmasterReportUrl = action.response.result;
      return state
        .set('csvDataAvailably', true)
        .set('automaticMasterReportData', automaticmasterReportUrl);
    }
    case type.SET_ALL_MASTER_USER_REPORT_LOADING: {
      return state.set('allMasterUserReportLoading', action.value);
    }
    case type.SET_ALL_ACTIVE_SUBSCRIPTIONS_REPORT:
      return state
        .set('csvDataSubsActive', true)
        .set('automaticSubscriptionsReport', action.response.result);
    case type.SET_ALL_ACTIVE_SUBSCRIPTIONS_REPORT_LOADING: {
      return state.set('allActiveSubscriptionsReportLoading', action.value);
    }
    case type.CLEAR_AUTOMATIC_MASTER_REPORT_PROPS:
      return state
        .set('automaticMasterReportData', [])
        .set('csvDataAvailably', false);
    case type.CLEAR_AUTOMATIC_ACTIVE_SUBSCRIPTIONS:
      return state
        .set('automaticSubscriptionsReport', [])
        .set('csvDataSubsActive', false);
    case type.SET_IS_USER_SUBMITTED_QUESTIONS_REPORT_FOR_RATES_LOADING:
      return state.set('isUserSubmittedQuestionsReportLoading', action.value);
    case type.SET_USER_SUBMITTED_QUESTIONS_REPORT_FOR_RATES:
      return state.set('userSubmittedQuestionsReportCSVJson', action.response);
    case type.SET_USER_SUBMITTED_QUESTIONS_REPORT_FOR_RATES_ERROR:
      return state.set('userSubmittedQuestionsReportError', action.error);

    /* Intercom Active Users Report */
    case type.GET_LATEST_INTERCOM_ACTIVE_USERS_REPORT:
      return state;
    case type.GENERATE_INTERCOM_ACTIVE_USERS_REPORT: {
      return state.set('intercomActiveUsersReport', {
        data: {},
        state: INTERCOM_ACTIVE_USERS_REPORT_LOADING,
      });
    }
    case type.SET_INTERCOM_ACTIVE_USERS_REPORT: {
      return state.set('intercomActiveUsersReport', {
        data: action.payload,
        state: action.payload.state || INTERCOM_ACTIVE_USERS_REPORT_SUCCESS,
      });
    }

    /* Favorite questions report */
    case type.SET_LAST_FAVORITE_QUESTIONS_REPORTS:
      return state.set('lastFavoriteQuestionsReports', action.reports);
    case type.LOADING_FAVORITE_QUESTIONS_REPORT: {
      const existingReports = state.get('lastFavoriteQuestionsReports');
      // create new reports if they don't exist (this works only the first time for each rate)
      const updatedReports = action.ratesIds.reduce(
        (reports, rateId) => {
          const existingReport = reports.find(
            (report) => report.rate === rateId,
          );
          if (existingReport) {
            existingReport.isLoading = true;
          } else {
            reports.push({ rate: rateId, isLoading: true });
          }
          return reports;
        },
        [...existingReports],
      );

      return state.set('lastFavoriteQuestionsReports', updatedReports);
    }

    /* Rate questions report */
    case type.SET_LAST_RATE_QUESTIONS_REPORTS:
      return state.set('lastRateQuestionsReports', action.reports);
    case type.LOADING_RATE_QUESTIONS_REPORT: {
      const existingReports = state.get('lastRateQuestionsReports');
      // create new reports if they don't exist (this works only the first time for each rate)
      const updatedReports = action.ratesIds.reduce(
        (reports, rateId) => {
          const existingReport = reports.find(
            (report) => report.rate === rateId,
          );
          if (existingReport) {
            existingReport.isLoading = true;
          } else {
            reports.push({ rate: rateId, isLoading: true });
          }
          return reports;
        },
        [...existingReports],
      );

      return state.set('lastRateQuestionsReports', updatedReports);
    }
    /* Usage statistics report */
    case type.SET_USAGE_REPORTS:
      return state.set('usageStatisticsReports', action.reports);
    case type.UPDATE_USAGE_REPORTS:
      return state.set('usageStatisticsReports', [
        ...state.get('usageStatisticsReports'),
        action.report,
      ]);
    case type.SET_USAGE_REPORTS_IS_LOADING:
      return state.set('usageStatisticsReportsIsLoading', action.value);

    /* Subscription types report */
    case type.SET_SUBSCRIPTION_TYPES_REPORTS:
      return state.set('subscriptionTypesReports', action.reports);
    case type.UPDATE_SUBSCRIPTION_TYPES_REPORTS:
      return state.set('subscriptionTypesReports', [
        ...state.get('subscriptionTypesReports'),
        action.report,
      ]);
    case type.SET_SUBSCRIPTION_TYPES_REPORTS_IS_LOADING:
      return state.set('subscriptionTypesReportsIsLoading', action.value);

    /* Books missing answers report */
    case type.GET_LATEST_BOOKS_MISSING_ANSWERS_REPORT:
    case type.GENERATE_BOOKS_MISSING_ANSWERS_REPORT:
      return state;
    case type.SET_BOOKS_MISSING_ANSWERS_REPORT_DATA:
      if (action.payload.state === BOOKS_MISSING_ANSWERS_REPORT_SUCCESS) {
        return state.set('booksMissingAnswersReportData', {
          state: action.payload.state,
          link: action.payload.link,
        });
      }
      return state;
    case type.SET_BOOKS_MISSING_ANSWERS_REPORT_STATE:
      return state.set('booksMissingAnswersReportState', action.payload.state);

    // Audio Report
    case type.GET_AUDIO_REPORTS:
      return state;
    case type.SET_AUDIO_REPORTS: {
      const newAudioStates = {};
      const newAudioData = {};
      action.payload.forEach((audioReport) => {
        newAudioStates[audioReport.rate] = audioReport.state;
        newAudioData[audioReport.rate] = {
          link: audioReport.link,
          updatedAt: audioReport.updatedAt,
        };
      });
      let newState = state;
      newState = newState.set('audioReportsState', newAudioStates);
      newState = newState.set('audioReportsData', newAudioData);
      return newState;
    }
    case type.GENERATE_AUDIO_REPORT:
      return state;
    case type.SET_AUDIO_REPORT_STATE: {
      const newAudioStates = { ...state.get('audioReportsState') };
      newAudioStates[action.payload.rate] = action.payload.state;
      return state.set('audioReportsState', newAudioStates);
    }
    case type.SET_AUDIO_REPORT_DATA: {
      const newAudioData = { ...state.get('audioReportsData') };
      newAudioData[action.payload.rate] = {
        link: action.payload.link,
        updatedAt: action.payload.updatedAt,
      };
      return state.set('audioReportsData', newAudioData);
    }

    case type.GET_LATEST_AUDIO_ABBREVIATIONS_REPORT:
      return state;
    case type.GENERATE_AUDIO_ABBREVIATIONS_REPORT: {
      return state.set('audioAbbreviationReport', {
        data: {},
        state: AUDIO_ABBREVIATIONS_REPORT_LOADING,
      });
    }
    case type.SET_AUDIO_ABBREVIATIONS_REPORT: {
      return state.set('audioAbbreviationReport', {
        data: action.payload,
        state: action.payload.state || AUDIO_ABBREVIATIONS_REPORT_SUCCESS,
      });
    }

    /* Referred Leads Report */
    case type.GET_LATEST_REFERRED_LEADS_REPORT:
    case type.GENERATE_REFERRED_LEADS_REPORT:
      return state;
    case type.SET_REFERRED_LEADS_REPORT_DATA:
      return state.set('referredLeadsReportData', {
        state: action.payload.state,
        link: action.payload.link || '',
      });
    case type.SET_REFERRED_LEADS_REPORT_STATE:
      return state.set('referredLeadsReportState', action.payload.state);

    /* Assigned to Writers Report */
    case type.GET_LATEST_ASSIGNED_TO_WRITERS_REPORT:
    case type.GENERATE_ASSIGNED_TO_WRITERS_REPORT:
      return state;
    case type.SET_ASSIGNED_TO_WRITERS_REPORT_DATA:
      return state.set('assignedToWritersReportData', {
        state: action.payload.state,
        link: action.payload.link || '',
      });
    case type.SET_ASSIGNED_TO_WRITERS_REPORT_STATE:
      return state.set('assignedToWritersReportState', action.payload.state);

    /* Self Promotion Status Report */
    case type.GET_LATEST_SELF_PROMOTION_REPORT:
    case type.GENERATE_SELF_PROMOTION_REPORT:
      return state;
    case type.SET_SELF_PROMOTION_REPORT_DATA:
      return state.set('selfPromotionReportData', {
        state: action.payload.state,
        link: action.payload.link || '',
      });
    case type.SET_SELF_PROMOTION_REPORT_STATE:
      return state.set('selfPromotionReportState', action.payload.state);

    default:
      return state;
  }
};

export default reportReducer;
